import React from "react";
import MyRouter from './Router';

const Setup = ()=>{
    return <MyRouter />
}

export default Setup;